/**
 * e.g.
 *
 * ```js
 * > accumulateStylePropertiesFromCustomStyleSections({
 *   button: { a: 123, b: 456 },
 *   bookButton: { b: 789, c: 12 },
 *   timetable: { c: 345, d: 678 },
 * }, ['button, 'bookButton']);
 *
 * { a: 123, b: 789, c: 12 }
 * ```
 * @template {Record<string, any>} TCustomStyle
 * @param {TCustomStyle | undefined} customStyle
 * @param {(keyof TCustomStyle)[]} customStyleSectionKeys
 * @returns {TCustomStyle[keyof TCustomStyle] | undefined}
 */
export function accumulateStylePropertiesFromCustomStyleSections(
  customStyle,
  customStyleSectionKeys
) {
  if (!customStyle) {
    return undefined;
  }
  const brand = {};
  // Accumulate properties from each of the customStyle sections.
  for (const customStyleSectionKey of customStyleSectionKeys) {
    if (typeof customStyle[customStyleSectionKey] !== 'undefined') {
      Object.assign(brand, customStyle[customStyleSectionKey]);
    }
  }
  return /** @type {TCustomStyle[keyof TCustomStyle]} */ (brand);
}
